import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAzure = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 122.88 95.07",
	style: { enableBackground: "new 0 0 122.88 95.07" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: ".azure{fill-rule:evenodd;clip-rule:evenodd;fill:#0089D6;}"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		className: "azure",
		d: "M56.8,90.01l28.96-5.12l0.27-0.06L71.13,67.12c-4.94-5.83-10.17-11.99-14.79-17.83 c0-0.09,15.38-42.43,15.46-42.58C71.83,6.66,82.3,24.73,97.17,50.5l25.51,44.23l0.19,0.34l-47.33-0.01l-47.33-0.01l28.68-5.06 L56.8,90.01L56.8,90.01z M0,84.62c0-0.02,7.02-12.21,15.59-27.07l15.59-27.03l18.17-15.25C59.35,6.89,67.56,0.01,67.59,0 c-0.07,0.26-0.17,0.5-0.29,0.74L47.56,43.06L28.18,84.62l-14.09,0.02C6.34,84.66,0,84.64,0,84.62L0,84.62L0,84.62z"
	}) })]
});
export default SvgAzure;
